// @ vendors
const React = require('react');

// @ commons
const { AmountInput } = require('commonsComponents/amountInput');
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ commons
const { getLanguage } = require('core/i18n').i18n;

const buildOKSelectList = (OKSelectData) => {
    return OKSelectData.map((item, idx)=>{
        return (
            <div className="row separator" key={idx}>
                <div className="col-md-12">
                    <OKSelect
                        label={item.label}
                        name={item.name}
                        options={item.options}
                        value={item.value}
                        clearable={item.clearable}
                        searchable={item.searchable}
                        disabled={item.disabled}
                        onChange={item.handleOnChange}
                    />
                </div>
            </div>
        )
    });
};

const buildAmountInputList = (amountInputData) => {
    return amountInputData.map((item, idx) => {
       return (
           <div className="row separator" key={idx}>
               <div className="col-md-12">
                   <AmountInput
                       name={item.name}
                       label={item.label}
                       amount={item.amount}
                       callback={item.callback}
                       error={item.error}
                       errorMsg={item.errorMsg}
                       maxFractionLength={item.maxFractionLength}
                       showBlurZero={item.showBlurZero}
                       disabled={item.disabled}
                       language={getLanguage()}
                   />
               </div>
           </div>
       )
   })
};

module.exports = {
    buildOKSelectList,
    buildAmountInputList
};
